import StandPhotoModal from "./stand-photo-modal";

export default StandPhotoModal;